import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { Reveal } from "./anim";

export default function Reviews() {
  const { t } = useLang();
  const r = t.reviews;

  return (
    <section id="reviews" className="relative py-24 md:py-36 bg-cream-2" data-testid="reviews-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <Reveal>
          <p className="text-xs tracking-[0.25em] uppercase text-brand mb-6">{r.overline}</p>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-[3.75rem] tracking-tight text-ink max-w-2xl">
            {r.title}
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {r.items.map((it, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 36 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1], delay: (i % 2) * 0.1 }}
              className="bg-cream rounded-tl-[2.5rem] rounded-br-[2.5rem] p-8 md:p-10 border border-ink/8 shadow-[0_10px_40px_rgba(45,42,38,0.05)]"
              data-testid={`review-${i}`}
            >
              <div className="flex gap-1 text-brand mb-5">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} size={16} fill="currentColor" strokeWidth={0} />
                ))}
              </div>
              <blockquote className="font-serif text-xl md:text-2xl leading-snug text-ink italic">
                “{it.text}”
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3">
                <span className="flex items-center justify-center w-10 h-10 rounded-full bg-brand/15 text-brand font-serif text-lg">
                  {it.name.charAt(0)}
                </span>
                <span>
                  <span className="block text-sm font-medium text-ink">{it.name}</span>
                  <span className="block text-xs tracking-[0.1em] uppercase text-ink-soft">{it.city}</span>
                </span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
